import React from 'react';
import CSSModules from 'react-css-modules';
import styles from './WorksPage.css';
import Everything from '../components/Everything';

function WorksPage(props, context) {
  document.title = 'Everything by Jennifer Zwick';

  return (
    <Everything />
  );
}

export default CSSModules(WorksPage, styles, { errorWhenNotFound: false });



// WEBPACK FOOTER //
// ./application/js/pages/WorksPage.js